export default '/build/9d781f7f.svg'